import React, { useState, useEffect, useMemo } from "react";
import { getCookie } from "../customer/Utility";
/**
 * Custom hook to fetch table headings from the API.
 * @returns {Array|null} An array of table column headings or null if fetching is in progress or failed.
 */
function useTableheading(reloadFlag) {
	const [columns, setColumns] = useState([]);

	let user_uuid = getCookie("muvi_useruuid"); //"acfdd41f64c94f098ec605efc72271a8"; //  getCookie("muvi_useruuid");
	useEffect(() => {
		fetch(`${process.env.REACT_APP_tattle_api}/tattle/list`, {
			//  REACT_APP_tattle_api
			method: "POST",
			body: JSON.stringify({
				app_token: process.env.REACT_APP_tattle_token,
				attribute_set_key: "crm",
				user_uuid: user_uuid ? user_uuid : "acfdd41f64c94f098ec605efc72271a8",
			}),
		})
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((res) => setColumns(res.data))
			.catch((error) => {
				console.error("Fetch error:", error);
				// Handle fetch error
				//setColumns([]);
			});
	}, [reloadFlag]);

	// Return columns only when available
	return columns;
}

export default useTableheading;



// WEBPACK FOOTER //
// ./src/components/crm/hooks/useTableheading.js